const initializeEmailOkay = () => {
  $(".js-email-okay").on("click", function emailOkay() {
    const emailField = document.querySelector(".js-email-field");
    emailField.setCustomValidity("");
  });
};
export default initializeEmailOkay;
